<template>
  <div class="container  mt-3">
    <div class="m-auto">
    	
      <div class="form-horizontal">
        
          <div class="form-group row">
            <label class="col-12 col-sm-4 col-form-label">Método de Pago</label>
            <div class="col-12 col-sm-4">
              <select v-model="metodo" class="form-control">
                <option disabled value="">Please select one</option>
                <option v-if="opciones" v-for="opcion in opciones" :value="opcion.codigo">{{ opcion.nombre }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-4 mt-3 mt-sm-0">
              <button v-if="procesable" class="btn btn-block btn-danger" @click="procesarObservacion">
                Guardar Método
              </button>
            </div>
          </div>
           
        
      </div>
    </div>
    
    <b-modal @ok="procesar" @cancel="observacion=''" v-model="changeObservacion"  id="modalObservacion"
    :ok-disabled="observacion.length<observacionMin"  title="Motivo del cambio">
      <div class="mb-2">
        <b-form-textarea
          id="textarea"
          v-model="observacion"
          placeholder="Cuéntanos, ¿por qué es necesario hacer este cambio?"
          rows="3"
          max-rows="6"
          maxlength="100"
        ></b-form-textarea>
        <pre class="d-block text-right">{{ observacion.length }}/{{ observacionMin }}</pre>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

  export default {
    name: 'DetalleMetodoPago',
    components: {
      
    },
    data () {
      return {
        metodo:null,
        
        changeObservacion:false,
        observacionMin:10,
        observacion:''
      }
    },
    props: {
      estudiante: Object
    },
    mounted () {
      if(!this.opciones || (this.opciones && this.opciones.length==0)){
        this.fetchMetodosPago()
      }
      if(this.estudiante){
        this.metodo = this.estudiante.tipo_pago  
      }else{
        console.log('Hay que asegurarse de tener un estudiante antes de utilizar el componente DetalleMetodoPago')
      }
    },
    methods:{
      ...mapActions({
        editarMetodoPago: 'estudiantes/editarMetodoPago',
        fetchMetodosPago: 'asw/fetchMetodosPago',
        fetchDetalle: 'estudiantes/fetchDetalle',
        setWarning: 'setWarning',
      }),
      ...mapMutations({
        
      }),
      procesar(){
        
        this.editarMetodoPago({
          id:this.estudiante.id,
          tipo_pago:this.metodo,
          observacion:this.observacion
        }).then((apiResponse)=>{
          
          this.limpiar()
          this.setWarning('Método de pago guardado.', { root: true }).then(()=>{
            this.fetchDetalle(this.estudiante.id).then(()=>{
              this.metodo = this.estudiante.tipo_pago  
              // this.$router.push('/estudiante/detalle/'+this.estudiante.id)
            }) 
          })
          
          
        })
      },
      procesarObservacion(){
        this.changeObservacion = true;
        this.observacion = '';
      },
      limpiar(){
        this.metodo = null
      }
    },
    computed:{
      ...mapState({
        opciones: state  => state.asw.metodos_pago,
      }),
      ...mapGetters({
        
      }),
      procesable: {
        get () {
          return (this.metodo && this.metodo != this.estudiante.tipo_pago)
        },
        set(value){}
      },
    }
  }
</script>

<style scope>
  .programar_wrapper .form-container{
      
  }
	.programar_wrapper{
    
	}
</style>

